var path = 'src/app/ui/loading.html';
var html = "<div class=well ng-show=loading><strong>{{message}}</strong> <i class=\"fa fa-spinner fa-spin\"></i></div> <div ng-show=!loading ng-transclude></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/ui/loading.html
 ** module id = 680
 ** module chunks = 0
 **/